module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "popup_close_icon24x24.ef4d896a.svg";